(() => {
  const dialog = document.getElementById('LntNewsletter');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const teaser = document.querySelector('[data-lnt-newsletter-open]');
  const scratch = dialog.querySelector('[data-lnt-newsletter-scratch]');
  const signup = dialog.querySelector('[data-lnt-newsletter-signup]');
  const fields = dialog.querySelector('[data-lnt-newsletter-fields]');
  const success = dialog.querySelector('[data-lnt-newsletter-success]');
  const error = dialog.querySelector('[data-lnt-newsletter-error]');
  const canvas = dialog.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const params = new URLSearchParams(location.search);
  const preview = params.get('lnt_newsletter_preview') === '1';
  const key = 'lntstep_newsletter_v2';
  let state = {};
  try { state = JSON.parse(localStorage.getItem(key) || '{}'); } catch {}
  const remember = (value) => { state = {...state,...value}; try { localStorage.setItem(key,JSON.stringify(state)); } catch {} };
  const discountLink = (target) => '/discount/LNT200?redirect=' + encodeURIComponent(target);
  const applyDiscount = async () => {
    const status = dialog.querySelector('[data-lnt-newsletter-apply-status]');
    if(status)status.textContent=status.dataset.pending;
    try {
      const response = await fetch(discountLink((window.Shopify?.routes?.root || '/') + 'cart'), {credentials:'same-origin'});
      if(!response.ok)throw new Error('discount-link');
      const result = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'});
      if(!result.ok)throw new Error('cart-read');
      const cart = await result.json();
      if(!cart.discount_codes?.some(item=>item.code.toUpperCase()==='LNT200'))throw new Error('discount-not-saved');
      remember({discountLinked:true});
      if(status)status.textContent=status.dataset.done;
    } catch { if(status)status.textContent=status.dataset.failed; }
  };
  dialog.querySelector('[data-lnt-newsletter-copy]')?.addEventListener('click', async () => {
    const status = dialog.querySelector('[data-lnt-newsletter-copy-status]');
    const code = dialog.querySelector('[data-lnt-newsletter-code]');
    let copied = false;
    try { await navigator.clipboard.writeText(code.textContent.trim()); copied = true; } catch {
      const field = document.createElement('textarea');
      field.value = code.textContent.trim(); field.setAttribute('readonly','');
      field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0';
      dialog.appendChild(field); field.select(); field.setSelectionRange(0,field.value.length);
      try { copied = document.execCommand('copy'); } catch {}
      field.remove();
    }
    if (!copied) { const selection = window.getSelection(); const range = document.createRange(); range.selectNodeContents(code); selection.removeAllRanges(); selection.addRange(range); }
    status.textContent = copied ? status.dataset.copied : status.dataset.fallback;
  });
  let revealed = false;
  let beforeOpen;
  const reveal = () => {
    if (revealed || success) return;
    revealed = true;
    dialog.removeAttribute('aria-labelledby');
    dialog.setAttribute('aria-label',signup.querySelector('h2').textContent);
    scratch.hidden = true;
    signup.hidden = false;
    fields.hidden = false;
    if (dialog.open) dialog.querySelector('input[type=email]').focus({preventScroll:true});
  };
  const open = () => {
    if (dialog.open) return;
    beforeOpen = document.activeElement;
    if (typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    teaser.hidden = true;
  };
  const close = () => dialog.close();
  dialog.querySelector('[data-lnt-newsletter-close]').addEventListener('click',close);
  dialog.addEventListener('click',(e) => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) close(); } });
  dialog.addEventListener('close',() => { remember({dismissedAt:Date.now()}); teaser.hidden = !!state.subscribed; beforeOpen?.focus?.({preventScroll:true}); });
  teaser.addEventListener('click',open);
  dialog.querySelector('[data-lnt-newsletter-reveal]').addEventListener('click',reveal);
  if (ctx) {
    const gradient = ctx.createLinearGradient(0,0,720,400);
    gradient.addColorStop(0,'#e6d5ab'); gradient.addColorStop(.4,'#c5aa6f'); gradient.addColorStop(1,'#eadcc0');
    ctx.fillStyle=gradient; ctx.fillRect(0,0,720,400);
    ctx.strokeStyle='#ffffff25'; ctx.lineWidth=2;
    for(let x=-400;x<1000;x+=32){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x+400,400);ctx.stroke();}
    ctx.fillStyle='#262019';ctx.textAlign='center';ctx.textBaseline='middle';ctx.font='800 37px Arial';ctx.fillText(canvas.dataset.label,360,200);
    let down=false,last=null,segments=0;
    const point = (e) => { const r=canvas.getBoundingClientRect(); return {x:(e.clientX-r.left)*720/r.width,y:(e.clientY-r.top)*400/r.height}; };
    const draw=(e)=>{
      if(!down||revealed)return;
      const p=point(e); ctx.globalCompositeOperation='destination-out';ctx.lineWidth=70;ctx.lineCap='round';ctx.beginPath();ctx.moveTo(last?.x??p.x,last?.y??p.y);ctx.lineTo(p.x,p.y);ctx.stroke();last=p;
      segments++;
      if(segments%12===0){const data=ctx.getImageData(0,0,720,400).data;let clear=0,total=0;for(let i=3;i<data.length;i+=160){total++;if(data[i]<100)clear++;}if(clear/total>.35){down=false;setTimeout(reveal,250);}}
    };
    canvas.addEventListener('pointerdown',e=>{down=true;last=null;canvas.setPointerCapture(e.pointerId);draw(e);});
    canvas.addEventListener('pointermove',draw);
    canvas.addEventListener('pointerup',()=>{down=false;last=null;});
    canvas.addEventListener('pointercancel',()=>{down=false;last=null;});
  }
  if(success){applyDiscount();scratch.hidden=true;signup.hidden=true;fields.hidden=true;dialog.removeAttribute('aria-labelledby');dialog.setAttribute('aria-label',success.querySelector('h2').textContent);remember({subscribed:true});open();return;}
  if(error){reveal();open();return;}
  if(state.subscribed && !preview){if(!state.discountLinked)applyDiscount();return;}
  teaser.hidden=false;
  if(preview){open();return;}
  if(dialog.dataset.designMode==='true')return;
  if(state.dismissedAt && Date.now()-state.dismissedAt<7*86400000)return;
  if(/\/(cart|account|challenge|checkouts)(\/|$)/.test(location.pathname))return;
  const blocked = [...document.querySelectorAll('dialog[open],.popup-open,[aria-modal=true]')].some(el => el.getClientRects().length > 0 && getComputedStyle(el).visibility === 'visible' && getComputedStyle(el).display !== 'none');
  if(!blocked)open();
})();
